import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client';
import './GraduateStudents.css';
import {groupBy} from 'lodash';

const GraduateStudents = ({client}) => {

    const [doc, setDoc] = useState([]);
    const [type, setType] = useState("Doctoral");

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'graduate_students'), {orderings : '[my.graduate_students.name]', pageSize: 100}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
    }, [client]);

    if(doc.length > 0){
        const students = groupBy(doc, d => d.data.type);
        return (
            <div className="Graduate-Students">
                <h2>Graduate Students</h2>
                <div className="menu">
                    <ul>
                        {Object.keys(students).map(d => <li key={d} className={type === d ? 'selected' : ''} onClick={() => setType(d)}>{d}</li>)}
                    </ul>
                </div>
                <div className="graduate-students">
                {students[type].map(d => (
                    <div key={d.id} className="graduate-student">
                        <div className="image"><img src={d.data.image.url} alt={d.data.name}/></div>
                        <div className="details">
                            <h2 className="name">{d.data.name.charAt(0) === "0" ? d.data.name.substring(1) : d.data.name}</h2>
                            <div className="dissertation">{d.data.dissertation}</div>
                            <div className="university">{d.data.university}</div>
                            {d.data.extra.map(e => <div className="extra" key={d.data.name+e.extra1}>{e.extra1}</div>)}
                        </div>
                    </div>
                ))}
                </div>
            </div>
        )
    } else {
        return <div className="Graduate-Students">Loading...</div>;
    }
    
};
export default GraduateStudents;